<template>
  <div>
    <b-modal
      v-if='showChangeOrderForm'
      v-model='showChangeOrderForm'
      ok-title='Zamknij'
      ok-only
      title='Zmień kolejność'
      @ok='() => showChangeOrderForm = false'
      size='lg'
      centered
    >
      <ChangeOrder />
    </b-modal>

    <b-row>
      <b-col>
        <b-button-group>
          <b-button
            variant='outline-primary'
            @click='() => actions.handleAddFlatPage()'
          >
            Dodaj
          </b-button>
          <b-button
            variant='outline-primary'
            @click='() => handleChangeOrder()'
          >
            Zmień kolejność
          </b-button>
        </b-button-group>
      </b-col>
      <b-col>
        <b-form-select
          v-model='selected'
          :options='flatpagesSelectOptions'
        />
      </b-col>  
    </b-row>
    <div>
      <div v-for='(flatPage, i) in form.doc.flatPages' :key='i'>
        <flat-page
          v-if='selected === flatPage.id || selected === 0'
          :flatPage='flatPage'
        />
      </div>
    </div>
  </div>
</template>

<script>

  import FlatPage from './FlatPage'
  import ChangeOrder from './ChangeOrder'
  import { handleAddFlatPage } from '../../store/utils.js'
  
  export default {
    components: {
      FlatPage,
      ChangeOrder,
    },
    data() {
      return {
        showChangeOrderForm: false,
        selected: 0,
        actions: {
          handleAddFlatPage,
        },
      }
    },
    methods: {
      handleChangeOrder() {
        this.showChangeOrderForm = true
      },
    },
    computed: {
      form() {
        return this.$store.state.fanzones.form
      },
      flatpagesSelectOptions() {
        let options = []
        if (this.form.doc.flatPages && this.form.doc.flatPages.length > 0) {
          options = this.form.doc.flatPages.map((flatPage) => ({ value: flatPage.id, text: flatPage.title.pl }))
        }
        return [{ value: 0, text: 'Wszystkie' }, ...options]
      },
    },
  }

</script>